import { THEME } from "../theme";

export const MIGRATION_SPECIES = [
  { name: "Chinook (Spring)", months: [2,3,4,5,6], peak: [3,4], color: THEME.salmon, shift: -1.7 },
  { name: "Chinook (Fall)", months: [7,8,9,10], peak: [8,9], color: "#f97316", shift: -1.2 },
  { name: "Sockeye", months: [5,6,7,8,9], peak: [6,7], color: "#ef4444", shift: +0.8 },
  { name: "Coho", months: [8,9,10,11], peak: [9,10], color: "#fb7185", shift: -1.5 },
  { name: "Chum", months: [9,10,11,0], peak: [10,11], color: "#a78bfa", shift: -3.5 },
  { name: "Pink", months: [7,8,9], peak: [8], color: "#f472b6", shift: -3.5 },
  { name: "Steelhead", months: [5,6,7,8,9,10], peak: [6,7,8], color: "#22d3ee", shift: -1.0 },
];

export const HABITAT_LOSS_PROJECTIONS = [
  { species: "Chinook", loss: 86, color: THEME.salmon },
  { species: "Sockeye", loss: 45, color: "#f97316" },
  { species: "Steelhead", loss: 36, color: "#22d3ee" },
  { species: "Coho", loss: 30, color: "#fb7185" },
  { species: "Pink", loss: 30, color: "#f472b6" },
  { species: "Chum", loss: 30, color: "#a78bfa" },
];

export const ML_ARCHITECTURE_LAYERS = [
  { layer: "Data Ingestion", tools: "ERDDAP → Rust ETL → TimescaleDB", status: "Designed" },
  { layer: "Feature Engineering", tools: "SST anomalies, PDO/NPI, river flow, photoperiod", status: "Designed" },
  { layer: "Run Timing Model", tools: "GET-inspired Gaussian mixture (Python/PyTorch)", status: "Planned" },
  { layer: "Thermal Exposure", tools: "WCOFS + plume overlay → degree-day accumulation", status: "Planned" },
  { layer: "RAG Knowledge", tools: "LangChain + pgvector over regulatory corpus", status: "Prototype" },
  { layer: "Visualization", tools: "React + D3 + Deck.gl map layers", status: "Active" },
];

export const MONTH_NAMES = ["J","F","M","A","M","J","J","A","S","O","N","D"];
